import { Dialog } from "@material-ui/core";
import styled from "styled-components";

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding-right: 24px;
  padding-top: 24px;
  cursor: pointer;
  align-self: flex-end;
`;

export const ModalStyled = styled(Dialog)`
  top: 8% !important;
  border-radius: 4px !important;
`;
